import LineChart from './LineChart';

interface IntroTimelineScreenProps {
  onNext: () => void;
}

export default function IntroTimelineScreen({ onNext }: IntroTimelineScreenProps) {
  return (
    <div
      className="flex flex-col w-full h-screen"
      style={{
        background: 'linear-gradient(170deg, #1A1B2E 0%, #2D1B3D 60%, #1F1A35 100%)',
        overflowY: 'auto',
        overflowX: 'hidden',
        WebkitOverflowScrolling: 'touch',
      }}
    >
      {/* Progress dots */}
      <div className="flex justify-center gap-2 pt-12 pb-4">
        {[0, 1, 2, 3].map((i) => (
          <div
            key={i}
            style={{
              width: i === 2 ? '20px' : '6px', height: '6px',
              borderRadius: '3px',
              background: i <= 2 ? '#3ECFA0' : 'rgba(255,255,255,0.2)',
            }}
          />
        ))}
      </div>

      <div className="px-5 pt-6 flex-1">
        <p style={{ fontSize: '20px', fontWeight: 700, color: '#F5F5F7', lineHeight: 1.4, marginBottom: '6px', paddingLeft: '4px' }}>
          Ваша эмоциональная история
        </p>

        {/* Chart card */}
        <div
          className="mt-4 rounded-3xl"
          style={{
            background: 'rgba(255,255,255,0.05)',
            border: '1px solid rgba(255,255,255,0.08)',
            padding: '18px 16px',
          }}
        >
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '14px' }}>
            <span style={{ fontSize: '16px', fontWeight: 600, color: '#F5F5F7' }}>Август 2025</span>
            <div style={{ display: 'flex', gap: '10px' }}>
              {[
                { color: '#3ECFA0', label: 'Рад' },
                { color: '#4A90E2', label: 'Печ' },
                { color: '#8B7AB8', label: 'Стр' },
                { color: '#FF6B6B', label: 'Гнев' },
              ].map((e) => (
                <div key={e.label} style={{ display: 'flex', alignItems: 'center', gap: '3px' }}>
                  <div style={{ width: '7px', height: '7px', borderRadius: '50%', background: e.color }} />
                  <span style={{ fontSize: '9px', color: '#A8B2C8' }}>{e.label}</span>
                </div>
              ))}
            </div>
          </div>
          <LineChart days={31} height={140} showLegend={false} />
        </div>

        {/* Text below chart */}
        <p style={{ fontSize: '15px', fontWeight: 400, color: '#A8B2C8', lineHeight: 1.7, marginTop: '20px', paddingLeft: '4px' }}>
          Чем чаще вы будете делиться воспоминаниями, тем подробнее сможете видеть, как менялась ваша жизнь.
        </p>
      </div>

      {/* Button */}
      <div
        className="px-7"
        style={{ paddingBottom: 'calc(32px + env(safe-area-inset-bottom))' }}
      >
        <button
          onClick={onNext}
          className="w-full active:scale-95 transition-transform duration-150"
          style={{
            height: '56px', borderRadius: '28px',
            background: 'linear-gradient(135deg, #3ECFA0, #2BA87F)',
            border: 'none', fontSize: '17px', fontWeight: 600, color: '#fff',
            cursor: 'pointer', boxShadow: '0 8px 24px rgba(62,207,160,0.35)',
          }}
        >
          Далее
        </button>
      </div>
    </div>
  );
}
